import { useState, useEffect } from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { AppLayout } from '@/components/layout/AppLayout';
import { getAppConfig } from '@/lib/config';

export function DebugConfigPage() {
  const [config, setConfig] = useState<any>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    setConfig(getAppConfig());
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <AppLayout showSearch={false}>
      <Container maxWidth="lg">
        <Typography variant="h4" component="h1" gutterBottom>
          環境設定デバッグ
        </Typography>

        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            現在の設定
          </Typography>

          <Box sx={{ mt: 2 }}>
            <Typography
              variant="body1"
              component="pre"
              sx={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap' }}
            >
              {JSON.stringify(config, null, 2)}
            </Typography>
          </Box>
        </Paper>

        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            環境変数（Vite）
          </Typography>

          <Box sx={{ mt: 2 }}>
            <Typography variant="body2">
              VITE_APP_ENV: {import.meta.env.VITE_APP_ENV || '未設定'}
            </Typography>
            <Typography variant="body2">
              VITE_BACKEND_API_URL: {import.meta.env.VITE_BACKEND_API_URL || '未設定'}
            </Typography>
            <Typography variant="body2">MODE: {import.meta.env.MODE || '未設定'}</Typography>
          </Box>
        </Paper>
      </Container>
    </AppLayout>
  );
}
